module.exports = {
	assessmentTab: 'hash',

	resultsTab: {
		store: 'hash',
		pushState: true
	},

	resultsSubTab: 'hash',

	qset: {
		store: 'hash',
		type: Number
	},

	resultsQset: 'hash',

	q: 'hash',

	answerKey: {
		store: 'hash',
		type: 'boolean'
	},

	wsTab: 'hash', // student workspace tab

	student: 'hash',

	articleTab: {
		store: 'hash',
		pushState: true
	},

	stepreadsSection: {
		store: 'hash'
	},

	vocabularySection: {
		store: 'hash'
	},

	contentSection: {
		store: 'hash'
	},

	questionsetsSection: {
		store: 'hash'
	},

	decodablesSection: {
		store: 'hash',
		type: Number
	},

	decodablesArticle: {
		store: 'hash'
	},

	teacherTipTab: {
		store: 'hash',
		pushState: true
	},

	bokResults: 'hash',

	bokResultsByStudent: 'hash',

	myAccountTab: {
		store: 'hash',
		pushState: true
	},

	// This value carries the product ID the user was looking at when
	// they created a class so we can offer a back button to it
	returnToProduct: 'hash',

	newClass: 'memory',

	forceAccountChooser: 'localStorage',

	tokenExpiration: 'localStorage',

	forceTokenExpiration: 'localStorage',

	aadTeacherTipTab: 'hash',

	howToTeacherTipTab: 'hash',

	userContext: 'localStorage',

	donationModalShown: 'memory',

	account: 'session',

	signUpReturnUrl: 'memory',

	//find-articles query params
	g: {
		store: 'hash',
		pushState: true,
		type: 'listOfNumbers'
	},
	t: {
		store: 'hash',
		pushState: true,
		type: 'listOfNumbers'
	},
	s: {
		store: 'hash',
		pushState: true,
		type: 'listOfNumbers'
	},
	k: {
		store: 'hash',
		pushState: true,
		type: 'list'
	},
	cid: {
		store: 'hash',
		pushState: true,
		type: 'list'
	},
	s0: {
		store: 'hash',
		pushState: true,
		type: 'list'
	},
	f: {
		store: 'hash',
		pushState: true,
		type: Number
	},
	lc: {
		store: 'hash',
		pushState: true,
		type: 'list'
	},
	l: {
		store: 'hash',
		pushState: true,
		type: 'list'
	},
	pt: {
		store: 'hash',
		pushState: true,
		type: 'list'
	},
	sr: {
		store: 'hash',
		pushState: true,
		type: 'json'
	},
	features: {
		store: 'hash',
		pushState: true,
		type: 'list'
	},
	staff_picks: {
		store: 'hash',
		pushState: true,
		type: 'list'
	},
	sel: {
		store: 'hash',
		pushState: true,
		type: 'list'
	},
	at: {
		store: 'hash',
		pushState: true,
		type: 'list'
	},
	subType: {
		store: 'hash',
		pushState: true,
		type: 'list'
	},
	book: {
		store: 'hash',
		pushState: true,
		type: Number
	},
	wc: {
		store: 'hash',
		pushState: true,
		type: 'list'
	},
	series: {
		store: 'hash',
		pushState: true,
		type: 'list'
	},

	searchResultQueryString: 'memory',

	classAdmin: 'hash',

	archiveMessageDismiss: 'localStorage',

	assignmentTab: 'hash',

	assignmentListTab: 'hash',

	classCode: 'hash',

	studentProgressTab: 'hash',

	studentId: 'hash',

	roster: 'memory',

	studentProgressResults: 'memory',

	studentProgressMonth: 'memory',

	studentProgressMonthIndividual: 'memory',

	studentProgressHash: 'memory',

	inviteStudents: 'hash',

	classes: 'memory',

	activeClasses: 'memory',

	cvaEligbleClasses: 'memory',

	previousCVAAssignments: 'memory',

	cvaAssignments: 'memory',

	studentCVAAssignment: 'memory',

	cvaProduct: 'memory',

	whiteboardView: 'memory',

	activeProduct: 'memory',

	ebookPage: {
		store: 'hash',
		pushState: false,
		type: Number
	},

	welcomeCoteacher: 'memory',

	currentClassAssignments: 'memory',

	noteId: 'hash',

	selectedQID: {
		store: 'hash',
		type: Number
	},

	whatsNewDismissSession: 'session',

	sessionStore: 'localStorage',

	temporarySessionStore: 'localStorage',

	activeClass: 'session',

	disableCopyPaste: 'session',

	teacherStatusMessageShown: 'session',

	studentStatusMessageShown: 'session',

	splitTab: 'memory',

	splitScreen: 'memory',

	studentTab: 'hash',

	studentOffset: {
		store: 'hash',
		type: Number,
		pushState: true
	},

	bigBok: 'memory',

	studentAssignmentsBackLink: 'memory',

	bigBokMonth: 'memory',

	seeAll: {
		type: Boolean,
		store: 'hash'
	},

	subArticleLink: 'memory',

	summerReadingButterbarDismiss: 'session',

	assessmentExportData: 'memory',

	studentProgressExportData: 'memory',

	individualStudentProgressExportData: 'memory',

	gcAccessToken: 'cookie',

	campaignId: 'cookie',

	source: 'cookie',

	category: 'cookie',

	sessionId: 'cookie',

	localGCAccessToken: 'session',

	gcAuthURL: 'session',

	gcClassList: 'session',

	showGCImportDialog: 'memory',

	onboardingClassData: 'session',

	classType: 'hash',

	className: 'memory',

	trainingTooltip: 'memory',

	bannerNotification: 'session',

	printing: {
		store: 'hash',
		type: 'boolean',
		pushState: false
	},

	rosterView: 'hash',

	studentGroups: 'memory',

	mq: 'memory',

	classBok: 'memory',

	studentCbok: 'memory',

	skiProduct: 'memory',

	skiAssignment: 'memory',

	skiAssignments: 'memory',

	skiTab: 'hash',

	skiResults: 'memory',

	skiRedirect: 'hash',

	rmsWorkspace: 'memory',

	productId: 'hash',

	libraryView: {
		store: 'hash',
		pushState: true
	},

	libraryResults: 'memory',

	libraryFavorites: 'memory',

	libraryReadingList: 'memory',

	libraryArticlesRead: 'memory',

	libraryRecommendations: 'memory',

	libraryProducts: 'memory',

	isp: 'hash',

	teacherLibraryResults: 'memory',

	studentLibrarySettings: 'memory',

	newLibraryProducts: 'memory',

	popularLibraryProducts: 'memory',

	articlesYouMightLike: 'memory',

	studentLibraryPromo: 'hash',

	hideStudentLibraryPromo: 'localStorage',

	studentProgressLibraryResults: 'memory',

	promoId: 'hash',

	promoLink: 'memory',

	graphicOrganizer: 'memory',

	articleDashboardTab: 'hash',

	graphicOrganizerInstructionsDismiss: 'session',

	whiteboardHighlightDismiss: 'localStorage',

	visitorDismiss: 'localStorage',

	summerOfReadWorks: 'hash',

	summerPurchaseGrade: 'localStorage',

	summerGrade: 'hash',

	returnToAADAH: 'memory',

	workspacePreviewModalDismiss: 'localStorage',

	workspacePreviewModalAssignment: 'memory',

	scopeSequenceLink: 'memory',

	skiWorkspaceBack: 'memory',

	submittedSchoolRemotenessBanner: 'memory',

	studentNotifications: 'memory',

	selectedGrades: {
		store: 'hash',
		type: 'list'
	},

	selectedSet: 'hash',

	expanded: 'hash',

	offlineModeAvailable: 'memory',

	workspaceUploadFailures: 'memory',

	/*** Offline mode / IndexedDB keys ***/

	offlineMode: 'memory',

	offlineUserContext: 'memory',

	offlineAssignments: 'memory',

	offlineTs: 'memory',

	offlineWorkspaceData: 'memory',

	offlineUploadProgress: 'memory',

	eventTimestampOffset: 'memory',

	offlineEvents: 'memory',

	/*** END Offline mode / IndexedDB keys ***/

	userSessionEventOffset: 'session',

	hasDownloadedAnAssignment: 'localStorage',

	enableOfflineModalHide: 'localStorage',

	idbWriteable: 'memory',

	eventExperimentGroup: 'session',

	distractionFreeView: 'memory',

	weeblyMenus: 'memory',

	loginChoice: 'localStorage',

	toolsTab: 'hash',

	contentTab: 'hash',

	dismissedJourneys: 'session',

	rosterRedirect: 'hash',

	dismissKor1ListeningLevelButterBar: 'session',

	hideKor1ListeningLevelButterBar: 'localStorage',

	sraid: 'hash',

	researchAssessments: 'memory',

	activeResearchAssessment: 'session',

	articleEntryPoint: 'memory',

	recommendedContent: 'session',

	dismissGroupStudentRemovalMessage: 'localStorage',

	recommendationsClassCode: 'memory',

	dismissTeacherGuideModal: 'localStorage',

	tgModalHideExpiration: 'localStorage',

	gcAddon: 'localStorage',

	milestoneData: 'session'
};
